import {
  Link,
  MaxWidthContent,
  PageWithSidebar,
  Button,
} from "@endya-conformite/ui-kit";
import ChevronLeft from "@endya-conformite/ui-kit/src/assets/icons/chevron-left.svg?react";
import { MainPageSidebar } from "@src/components/MainPageTemplate/MainPageSidebar";
import { UserMenu } from "@src/components/UserMenu/UserMenu";
import { PropsWithChildren } from "react";
import style from "./CmsPageTemplate.module.scss";

type ParametrePageTemplateProps = {
  isFullPage?: boolean;
  size?: "medium" | "big" | "large";
} & PropsWithChildren;

export function CmsPageTemplate({
  children,
  isFullPage = false,
  size = "large",
}: ParametrePageTemplateProps) {
  return (
    <PageWithSidebar sidebar={<MainPageSidebar />}>
      <div className={style.template}>
        <div className={style.scrollablePart}>
          <div className={style.header}>
            <Link to="/" className={style.back}>
              <Button variant="text" icon={<ChevronLeft />}>
                Retour à l&apos;accueil
              </Button>
            </Link>
            <div className={style.userMenuWrapper}>
              <UserMenu />
            </div>
          </div>

          <div className={style.content}>
            {isFullPage ? (
              children
            ) : (
              <MaxWidthContent size={size}>{children}</MaxWidthContent>
            )}
          </div>
        </div>
      </div>
    </PageWithSidebar>
  );
}
